import GlobalTypes from './global.types';

export type GlobalAction =
    | { type: typeof GlobalTypes.ADD_ERROR, payload: string }
    | { type: typeof GlobalTypes.ADD_SUCCESS, payload: string }
    | { type: typeof GlobalTypes.CLEAR_ERROR }
    | { type: typeof GlobalTypes.CLEAR_SUCCESS }
    | { type: typeof GlobalTypes.SET_CHANGING_STATE, payload: SetChangingStateAction }
    | { type: typeof GlobalTypes.ADD_SOFTPHONE_ERROR, payload: connect.SoftphoneError["errorType"] }
    | { type: typeof GlobalTypes.CLEAR_SOFTPHONE_ERROR }
    | { type: typeof GlobalTypes.INTERNET_CONNECTION; payload: boolean }
    | { type: typeof GlobalTypes.NUMBER_DIALLING; payload: string }
    | { type: typeof GlobalTypes.DO_REDIRECT; payload: {to:string,state:any} }
    | { type: typeof GlobalTypes.CLEAR_REDIRECT; }
    | { type: typeof GlobalTypes.SHOW_NOTIFICATION, payload: { type: "success" | "warning" | "error", header: string, text: string } }
    | { type: typeof GlobalTypes.SET_SA_IS_ALREADY_OPEN; payload: boolean }


export function setRedirect(to: string, state?:any): GlobalAction {
    return {
        type: GlobalTypes.DO_REDIRECT,
        payload: {
            to,
            state
        }
    }
}

export function clearRedirect(): GlobalAction {
    return {
        type: GlobalTypes.CLEAR_REDIRECT
    }
}

export function setNumberDialling(number: string): GlobalAction {
    return {
        type: GlobalTypes.NUMBER_DIALLING,
        payload: number
    }
}

export function setInternetConnection(isOnline: boolean): GlobalAction {
    return {
        type: GlobalTypes.INTERNET_CONNECTION,
        payload: isOnline
    };
}

export interface SetChangingStateAction {
    stateName: string;
}

export function addSoftphoneError(error: connect.SoftphoneError["errorType"]): GlobalAction {
    return {
        type: GlobalTypes.ADD_SOFTPHONE_ERROR,
        payload: error as string
    }
}

export function clearSoftphoneError(): GlobalAction {
    return {
        type: GlobalTypes.CLEAR_SOFTPHONE_ERROR
    }
}

export function addError(error: string): GlobalAction {
    return {
        type: GlobalTypes.ADD_ERROR,
        payload: error,
    };
}
export function addSuccess(success: string): GlobalAction {
    return {
        type: GlobalTypes.ADD_SUCCESS,
        payload: success,
    };
}

export function showNotification(type: "success" | "warning" | "error", header: string, text: string): GlobalAction {
    return {
        type: GlobalTypes.SHOW_NOTIFICATION,
        payload: {type, header, text}
    }
}

export function clearError(): GlobalAction {
    return {
        type: GlobalTypes.CLEAR_ERROR,
    };
}

export function clearSuccess(): GlobalAction {
    return {
        type: GlobalTypes.CLEAR_SUCCESS,
    };
}

export function setChangingState(stateName?: string): GlobalAction {
    return {
        type: GlobalTypes.SET_CHANGING_STATE,
        payload: {
            stateName: stateName || '',
        },
    };
}

export function setSaIsAlreadyOpen(saIsAlreadyOpen: boolean) : GlobalAction {
    return {
        type: GlobalTypes.SET_SA_IS_ALREADY_OPEN,
        payload: saIsAlreadyOpen
    }
} 
